import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import TextInput from "../TextInput";

const CellTextEditor = forwardRef((props, ref) => {
  const {
    value,
    InputProps,
    inputProps,
    onChange = () => {},
    onFocus = () => {},
    placeholder,
    isCancelAfterEnd = false,
    uppercase = false,
  } = props;
  const [controlledValue, setControlledValue] = useState(value);
  const cellref = useRef();
  const changeHandler = (e) => {
    if (uppercase) {
      setControlledValue(e.target.value?.toUpperCase());
    } else {
      setControlledValue(e.target.value);
    }
    onChange(e);
  };
  useImperativeHandle(ref, () => {
    return {
      getValue: () => controlledValue,
      isCancelAfterEnd: () => isCancelAfterEnd,
    };
  });
  useEffect(() => {
    cellref.current.focus({ preventScroll: true });
  }, []);
  useEffect(() => {
    setControlledValue(value);
  }, [value]);
  return (
    <TextInput
      ref={cellref}
      placeholder={placeholder}
      onChange={changeHandler}
      onFocus={onFocus}
      InputProps={{ ...InputProps, style: { background: "white" } }}
      value={controlledValue}
      inputProps={{ ...inputProps }}
    />
  );
});
export default CellTextEditor;
